import { useEffect, useRef } from "react";

/**
 * Adds `is-visible` when the element enters the viewport (once).
 * Pair with `.landing-reveal` in index.css.
 */
export function useRevealOnScroll<T extends HTMLElement>(
  rootMargin = "0px 0px -8% 0px",
) {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.classList.add("is-visible");
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        el.classList.add("is-visible");
        observer.unobserve(el);
      },
      { rootMargin, threshold: 0.12 },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return ref;
}
